import { fg } from '@atlassian/jira-feature-gating';

const WivAgentsRhsTabRelayProvider = {
	get(): boolean {
		return fg('wiv_agents_rhs_tab');
	},
};

export default WivAgentsRhsTabRelayProvider;
